import React from 'react';

interface FlagQuestionDialogProps {
  isOpen: boolean;
  questionNumber: number;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const FlagQuestionDialog: React.FC<FlagQuestionDialogProps> = ({
  isOpen,
  questionNumber,
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={(e) => {
        // Close dialog when clicking backdrop
        if (e.target === e.currentTarget) {
          onCancel();
        }
      }}
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 500, width: '90%' }}>
        <div className="modal-content">
          <div className="modal-header bg-warning text-dark">
            <h5 className="modal-title fw-bold">
              <i className="fas fa-flag me-2"></i>
              Report Question Issue
            </h5>
          </div>
          
          <div className="modal-body p-4">
            <div className="text-center mb-3">
              <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: '3rem' }}></i>
            </div>
            
            <h6 className="text-center mb-3 fw-bold">
              Report Question {questionNumber} as Invalid?
            </h6>
            
            <p className="text-muted text-center mb-4">
              You are about to report this question as having invalid content or incorrect options. 
              This will help improve the quality of future quizzes.
            </p>
            
            <div className="alert alert-info border-0" style={{ backgroundColor: '#e3f2fd' }}>
              <div className="small">
                <strong><i className="fas fa-info-circle me-2"></i>What happens next?</strong>
                <ul className="mt-2 mb-0 ps-3">
                  <li>Your report will be reviewed by administrators</li>
                  <li>This question will be excluded from future quiz scoring</li>
                  <li>You can continue with your current quiz normally</li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
              disabled={isLoading}
            >
              <i className="fas fa-times me-2"></i>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-warning"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Reporting...
                </>
              ) : (
                <>
                  <i className="fas fa-flag me-2"></i>
                  Report Question
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlagQuestionDialog;